import { formatCurrency } from "@/utils";
import * as S from "./styles";

export type ShippingFeeProps = {
  shippingFee?: number;
};

const ShippingFee: React.FC<ShippingFeeProps> = ({
  shippingFee = undefined,
}) => {
  return (
    <>
      {!isNaN(shippingFee as number) && shippingFee! > 0 ? (
        <S.ShippingFeeContainer>
          <S.ShippingFeeLabel>Shipping fee:</S.ShippingFeeLabel>
          <S.ShippingFeeValue>
            {formatCurrency(shippingFee as number)}
          </S.ShippingFeeValue>
        </S.ShippingFeeContainer>
      ) : undefined}
    </>
  );
};

export default ShippingFee;
